import { render, staticRenderFns } from "./WizardView.vue?vue&type=template&id=491bb5bd&scoped=true&"
import script from "./WizardView.vue?vue&type=script&lang=js&"
export * from "./WizardView.vue?vue&type=script&lang=js&"
import style0 from "./WizardView.vue?vue&type=style&index=0&id=491bb5bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491bb5bd",
  null
  
)

export default component.exports